import { render } from "./SpecPageList.vue?vue&type=template&id=154abb39&scoped=true&ts=true"
import script from "./SpecPageList.vue?vue&type=script&lang=ts"
export * from "./SpecPageList.vue?vue&type=script&lang=ts"

import "./SpecPageList.vue?vue&type=style&index=0&id=154abb39&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154abb39"]])

export default __exports__